export const esriOptions = () => {
    return sessionStorage.getItem("rcEsriOptions");
};

export const axiosBaseURL = () => {
    return sessionStorage.getItem("rcAxiosBaseURL");
};

export const axiosDelay = () =>{
    return sessionStorage.getItem("rcAxiosDelay");
};